import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Grid, Button } from "@material-ui/core";
import InputIcon from "@material-ui/icons/Input";
import CustomTextField from "../common/customTextField/CustomTextField";
import { Formik } from "formik";
import api from "../../api";
import "./Login.scss";
import iconLogo from "../../img/logo.png";
import { MainContext } from "../../context/MainContext";
import { useDispatch } from "react-redux";
import { AuthTypes } from "../../redux/actions/_types";

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("tokenLog");

  const { setDataToast, setIsLoading } = useContext(MainContext);
  function login(e) {
    setIsLoading(true);
    api
      .auth(e.username, e.password)
      .then(async (res) => {
        setIsLoading(false);
        if (res["result"]) {
          let { data } = await api.getDecoded();
          if (data) {
            dispatch({
              type: AuthTypes.LOGIN_SUCCESS,
              token,
              decoded: data,
            });
          }
          navigate("/inicio");
        } else {
          setDataToast({
            active: true,
            type: "error",
            message: res["message"],
          });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setDataToast({
          active: true,
          type: "error",
          message: "Ocurrió un error.",
        });
      });
  }

  return (
    <Grid container spacing={0} direction="column" alignItems="center" justify="center" className="c-login">
      <Grid className="c-w-100" item md={4} xs={8}>
        <Card className="c-p-15 c-login-card" elevation={3}>
          <Formik initialValues={{ username: "", password: "" }} onSubmit={(values) => login(values)}>
            {({ values, errors, handleChange, handleBlur, handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Grid className="c-text-center" container spacing={1}>
                  <Grid className="c-mb-15" item md={12} xs={12}>
                    <img className="c-img" src={iconLogo} alt="logo" />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      Name="username"
                      Label="Usuario"
                      Value={values.username}
                      Error={errors.name}
                      Change={handleChange}
                      Blur={handleBlur}
                      Required={true}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      Name="password"
                      Type="password"
                      Label="Contraseña"
                      Value={values.password}
                      Error={errors.password}
                      Change={handleChange}
                      Blur={handleBlur}
                      Required={true}
                    />
                  </Grid>
                  <Grid className="c-mt-15 c-text-center" item md={12} xs={12}>
                    <Button type="submit" className="c-btn-primary" variant="contained" startIcon={<InputIcon />}>
                      INGRESAR
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </Card>
      </Grid>
    </Grid>
  );
}
